








































import { Vue, Prop, Component } from 'vue-property-decorator';
import UserModule from '@/store/modules/user';
import FlagUtil from '@/util/FlagUtil';

@Component({
  components: {},
})
export default class TabbedNavigation extends Vue {
  @Prop({}) menuId!: string;

  @Prop({}) scheduleEnabled!: string;

  private menus = [
    {
      flag: 'unit.scheduleSettings',
      id: 'schedule',
      name: 'Schedule Setting',
      prop: 'scheduleEnabled',
    },
    {
      id: 'nonWorkingDays',
      name: 'Non-Working Days',
    },
    {
      id: 'facilityDetails',
      name: 'Facility Details',
    },
  ];

  get menusPermitted() {
    if (UserModule.currentRole === 'unit_manager') {
      return [
        {
          id: 'nonWorkingDays',
          name: 'Non-Working Days',
        },
        {
          id: 'facilityDetails',
          name: 'Facility Details',
        },
      ];
    }
    return this.menus;
  }

  public onClickTab(id: any) {
    this.$emit('menuid', id);
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  get unitUser() {
    if (UserModule.currentRole === 'unit_manager') {
      return UserModule.currentRole;
    }
    return null;
  }

  checkFlag(flag?: string) {
    if (!flag) return true;
    return FlagUtil.hasFeature(flag);
  }

  checkProp(propname?: string) {
    if (!propname) return true;

    return this[propname];
  }
}
